import moment from 'moment';
import RideitPassenger, { IRideitPassenger } from './RideitPassenger';

export const RideitInvitationMessageDirective  = '[LINK]' as const;

export interface IRideitInvitation {
    id: string;
    link: string;
    passengers: IRideitPassenger[];
    expiresAt: moment.Moment | Date | string;
    sentAt: moment.Moment | Date | string;
    email: string;
    acceptedById: string;
    acceptedByName: string;
    acceptedAt?: moment.Moment | Date | string | null;
    createdBy: string;
    createdAt: moment.Moment | Date | string;
    revokedBy: string;
    revokedAt?: moment.Moment | Date | string | null;
}

export enum RideitInvitationStatus {
    Accepted = 'Accepted',
    Expired = 'Expired',
    Revoked = 'Revoked',
    Pending = 'Pending',
}

export class RideitInvitation implements IRideitInvitation {
    id: string;
    link: string;
    passengers: RideitPassenger[];
    expiresAt: moment.Moment | Date | string;
    sentAt: moment.Moment | Date | string;
    email: string;
    acceptedById: string;
    acceptedByName: string;
    acceptedAt?: moment.Moment | Date | string | null;
    createdBy: string;
    createdAt: moment.Moment | Date | string;
    revokedBy: string;
    revokedAt?: moment.Moment | Date | string | null;

    constructor(data?: IRideitInvitation | null) {
        this.id = data?.id ?? '';
        this.link = data?.link ?? '';
        this.passengers = data?.passengers?.map(p => new RideitPassenger(p)) ?? [];
        this.expiresAt = data?.expiresAt ?? '';
        this.sentAt = data?.sentAt ?? '';
        this.email = data?.email ?? '';
        this.acceptedById = data?.acceptedById ?? '';
        this.acceptedByName = data?.acceptedByName ?? '';
        this.acceptedAt = data?.acceptedAt ?? null;
        this.createdBy = data?.createdBy ?? '';
        this.createdAt = data?.createdAt ?? '';
        this.revokedBy = data?.revokedBy ?? '';
        this.revokedAt = data?.revokedAt ?? null;
    }

    get status() {
        if (this.isDefinedDateTime(this.acceptedAt)) {
            return RideitInvitationStatus.Accepted;
        }
        if (this.isDefinedDateTime(this.revokedAt)) {
            return RideitInvitationStatus.Revoked;
        }
        const now = moment();
        const expiresAtMoment = moment(this.expiresAt);
        if (expiresAtMoment.isBefore(now)) {
            return RideitInvitationStatus.Expired;
        }
        return RideitInvitationStatus.Pending;
    }

    private isDefinedDateTime(dateTime: moment.Moment | Date | string | null | undefined) {
        if (dateTime === null || dateTime === undefined) {
        return false;
        }
        return true;
    }
}

export default RideitInvitation;